// Snipe Streak Boost — 3 successful snipes in one calendar day (UTC) arms a
// temporary +10% chip boost that lasts 6 hours. Purely client-side; the
// snipes-today count is authoritative on the server (/api/snipes/summary).

const KEY = "ppe_snipe_boost_v1"; // { until: epoch_ms }
const DURATION_MS = 6 * 60 * 60 * 1000;
export const SNIPE_BOOST_PCT = 0.10;

/** Called after fetching /api/snipes/summary. If snipesToday >= 3 and no
 *  boost is active, arm the boost for 6h. Returns { armed, alreadyActive }. */
export function maybeArmSnipeBoost(snipesToday) {
  const active = isSnipeBoostActive();
  if (active) return { armed: false, alreadyActive: true };
  if ((snipesToday || 0) < 3) return { armed: false, alreadyActive: false };
  localStorage.setItem(KEY, JSON.stringify({ until: Date.now() + DURATION_MS }));
  return { armed: true, alreadyActive: false };
}

export function isSnipeBoostActive() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return false;
    const doc = JSON.parse(raw);
    if (!doc || typeof doc.until !== "number") return false;
    if (Date.now() > doc.until) {
      localStorage.removeItem(KEY);
      return false;
    }
    return true;
  } catch { return false; }
}

export function snipeBoostMsRemaining() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return 0;
    const doc = JSON.parse(raw);
    const rem = doc.until - Date.now();
    return rem > 0 ? rem : 0;
  } catch { return 0; }
}
